var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { invariant } from "../utils.js";
import { ProfileObject, } from "./utils.js";
// ---------------------------------------------------------------------------
// Arusha namespace — function-based API
// ---------------------------------------------------------------------------
export var Arusha;
(function (Arusha) {
    function getCompanyTags(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = ctx.url.joinPath(`/v1/api/company/${companyId}/tags`);
            const res = yield ctx.fetch(url, {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    Arusha.getCompanyTags = getCompanyTags;
    function createCompanyTags(ctx, companyId, tag) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = ctx.url.joinPath(`/v1/api/company/${companyId}/tags`);
            const res = yield ctx.fetch(url, {
                method: "POST",
                body: JSON.stringify(tag),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.createCompanyTags = createCompanyTags;
    function updateCompanyTag(ctx, companyId, tag) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = ctx.url.joinPath(`/v1/api/company/${companyId}/tags/${tag.key}`);
            const res = yield ctx.fetch(url, {
                method: "PATCH",
                body: JSON.stringify(tag),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.updateCompanyTag = updateCompanyTag;
    function deleteCompanyTag(ctx, companyId, tagKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = ctx.url.joinPath(`/v1/api/company/${companyId}/tags/${tagKey}`);
            const res = yield ctx.fetch(url, {
                method: "DELETE",
            });
            return (yield res.json());
        });
    }
    Arusha.deleteCompanyTag = deleteCompanyTag;
    function queryCompany(ctx, param) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = new URLSearchParams();
            if (param.domain) {
                q.set("domain", param.domain);
            }
            if (param.publicId) {
                q.set("public_id", param.publicId);
            }
            if (param.id) {
                q.set("id", param.id);
            }
            let url = ctx.url.joinPath("/v1/api/query/company");
            url.search = q.toString();
            const res = yield ctx.fetch(url, {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    Arusha.queryCompany = queryCompany;
    function getCompanyAttributes(ctx, companyId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const form = new URLSearchParams();
            if (fields) {
                form.set("fields", fields.join(","));
            }
            let url = ctx.url.joinPath("/v1/api/company", companyId, "/attributes");
            url.search = form.toString();
            const res = yield ctx.fetch(url, {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    Arusha.getCompanyAttributes = getCompanyAttributes;
    function getCompanies(ctx, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = new URLSearchParams();
            if (query === null || query === void 0 ? void 0 : query.limit) {
                q.set("limit", query.limit.toString());
            }
            let url = ctx.url.joinPath("/v1/api/companies");
            url.search = q.toString();
            const res = yield ctx.fetch(url, {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    Arusha.getCompanies = getCompanies;
    function getCompanyUserAttributes(ctx, companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const form = new URLSearchParams();
            if (data === null || data === void 0 ? void 0 : data.fields) {
                for (const key of data.fields) {
                    form.append(`key`, key);
                }
            }
            let url = ctx.url.joinPath("/v1/api/company", companyId, "/users", data.userId, "/query/attributes");
            const res = yield ctx.fetch(url, {
                method: "POST",
                body: form.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.getCompanyUserAttributes = getCompanyUserAttributes;
    function queryCompanyEmployees(ctx, companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const form = new URLSearchParams();
            for (const [vk, entry] of Object.entries(data !== null && data !== void 0 ? data : {})) {
                // Skip keys that were passed but left unset (e.g. `cursor: undefined` on
                // the first page of a paginated query). Calling `.toString()` on these
                // would throw and break the whole request.
                if (entry === undefined || entry === null) {
                    continue;
                }
                switch (vk) {
                    case "select": {
                        for (const [key, value] of Object.entries(entry)) {
                            if (value) {
                                if (Array.isArray(value)) {
                                    for (const v of value) {
                                        form.append(`select[${key}]`, v);
                                    }
                                }
                                else {
                                    form.append(`select[${key}]`, value);
                                }
                            }
                        }
                        break;
                    }
                    case "fields": {
                        form.append("fields", entry.join(" "));
                        break;
                    }
                    default:
                        form.append(vk.toLowerCase(), entry.toString());
                        break;
                }
            }
            let url = ctx.url.joinPath("/v1/api/company", companyId, "/employees/query");
            const res = yield ctx.fetch(url, {
                method: "POST",
                body: form.toString(),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.queryCompanyEmployees = queryCompanyEmployees;
    /**
     * Fetches the ACL for the authenticated user that is a manager of the given
     * company. Returns the user's scopes, optional scope token, and role.
     */
    function getManagerACL(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.fetch(ctx.url.joinPath("/v1/api/acl/company", companyId, "/"), { method: "GET" });
            return (yield res.json());
        });
    }
    Arusha.getManagerACL = getManagerACL;
    /**
     * Fetches the authenticated user's profile items for the requested keys.
     * Returns a `ProfileObject` for convenient key-based access.
     */
    function getUserProfile(ctx, keys) {
        return __awaiter(this, void 0, void 0, function* () {
            const qs = new URLSearchParams();
            qs.set("fields", keys.join(" "));
            let url = ctx.url.joinPath("/v1/api/user/profile");
            url.search = qs.toString();
            const res = yield ctx.fetch(url, { method: "GET" });
            const values = (yield res.json());
            return new ProfileObject(values);
        });
    }
    Arusha.getUserProfile = getUserProfile;
    /**
     * Returns the list of managers / owners for the given company, guarded by
     * the provided scope token.
     */
    function getCompanyManagement(ctx, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.fetch(ctx.url.joinPath("/v1/api/company", companyId, "/management"), {
                method: "GET",
            });
            return (yield res.json());
        });
    }
    Arusha.getCompanyManagement = getCompanyManagement;
    /**
     * Upserts profile attributes for a company.
     * Pass an array of key-value pairs; returns the number of rows updated.
     */
    function setCompanyProfileAttributes(ctx, companyId, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.fetch(ctx.url.joinPath("/v1/api/company", companyId, "/attributes"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(attributes),
            });
            return (yield res.json());
        });
    }
    Arusha.setCompanyProfileAttributes = setCompanyProfileAttributes;
    function setEmployeeProfileAttributes(ctx, companyId, attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ctx.fetch(ctx.url.joinPath("/v1/api/company", companyId, "/employees/profiles"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(attributes),
            });
            return (yield res.json());
        });
    }
    Arusha.setEmployeeProfileAttributes = setEmployeeProfileAttributes;
    /**
     * Registers the user onto the KYC platform
     * @param arusha
     * @param ctx
     * @param input
     * @returns
     */
    function registerMember(arusha, input) {
        return __awaiter(this, void 0, void 0, function* () {
            invariant(input.companyId, "companyId is required");
            const res = yield arusha.fetch(arusha.url.joinPath("/v1/api/company", input.companyId, "members"), {
                method: "POST",
                body: JSON.stringify(input.data),
            });
            yield res.json();
        });
    }
    Arusha.registerMember = registerMember;
    function getCustomFields(arusha, companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield arusha.fetch(arusha.url.joinPath(`/v1/api/company/${companyId}/custom-fields`), {
                method: "GET",
                headers: {
                    Accept: "application/json",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.getCustomFields = getCustomFields;
    function setCustomFields(arusha, companyId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield arusha.fetch(arusha.url.joinPath(`/v1/api/company/${companyId}/custom-fields`), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
        });
    }
    Arusha.setCustomFields = setCustomFields;
    function createCompany(arusha, input) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield arusha.fetch(arusha.url.joinPath("/v1/api/admin/company/create"), {
                method: "POST",
                body: JSON.stringify(input),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return (yield res.json());
        });
    }
    Arusha.createCompany = createCompany;
})(Arusha || (Arusha = {}));
export default Arusha;
